import * as React from 'react'
import { IBaseProperty, IUIPropertyDefinition } from '../common'
import IconPickerField from '../icon-selector/IconPickerField'
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from './common'
import jp from 'jsonpath'
import { Input } from 'uxp/components'
import { hasProperty, hasValue } from '../../../util'
import { $L } from '../../../localize';
interface IIconProperty extends IBaseProperty {
    icon: string,
    color?: string
    size?: string,
}

export function extractIconProperties(props: IIconProperty, defaultIcon?: string): { icon: string, styles: React.CSSProperties } {
    if (!props) return { icon: defaultIcon || null, styles: {} }

    let icon = hasValue(props.icon) ? props.icon : defaultIcon || null
    let styles: React.CSSProperties = {}

    if (hasValue(props.color)) styles.color = props.color
    if (hasValue(props.size)) styles.fontSize = props.size
    return { icon, styles }
}

export function IconProperty(props: IIconProperty, title?: string): IUIPropertyDefinition<IIconProperty> {
    return {
        defaults: props,
        render: (props) => {

            let _props = props?.uiProps || { icon: '' }

            return <PropertyContainer>
                <PropertyContainerTitle>{title || $L('widgetdesigner.props.icon', 'Icon')}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property>
                        <PropertyTitle>{$L('widgetdesigner.props.icon', 'Icon')}</PropertyTitle>
                        <IconPickerField
                            value={_props.icon || ''}
                            onChange={s => {
                                jp.apply(_props, '$.icon', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    {hasProperty(_props, '$.color') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.color', 'Color')}</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.color || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.color', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }
                    {
                        hasProperty(_props, '$.size') && <>
                            <Property>
                                <PropertyTitle>{$L('widgetdesigner.props.size-px', 'Size (px)')} </PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(_props.size || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'

                                        jp.apply(_props, '$.size', () => (s + 'px'))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>

                        </>
                    }

                </PropertyGroup>
            </PropertyContainer>
        }
    }

}